const cleanList = (values = []) => Array.from(new Set(
  (Array.isArray(values) ? values : [])
    .map((value) => String(value || '').trim())
    .filter(Boolean)
));

const resolveStageLabel = (stageKey = '') => {
  const normalized = String(stageKey).toLowerCase();
  if (normalized === 'stage1') return 'Stage 1 (Document Review)';
  if (normalized === 'stage2') return 'Stage 2 (Main Audit)';
  return '';
};

export const buildAuditObjective = ({
  methodology,
  auditType,
  stageKey,
  standards,
} = {}) => {
  const standardLabels = cleanList(standards);
  const methodologyLabel = String(methodology || 'Single Audit').trim();
  const auditTypeLabel = String(auditType || 'Audit').trim();
  const stageLabel = resolveStageLabel(stageKey);
  const processLabel = [auditTypeLabel, stageLabel].filter(Boolean).join(' — ');
  const standardText = standardLabels.length > 0
    ? standardLabels.join(', ')
    : 'the applicable audit criteria';
  const integrated = /integrated/i.test(methodologyLabel);

  if (stageLabel.startsWith('Stage 1')) {
    return `To evaluate the documented ${integrated ? 'integrated ' : ''}management system against ${standardText} for ${processLabel}, confirm the audit scope and readiness, and identify any concerns that must be resolved before Stage 2.`;
  }

  if (stageLabel.startsWith('Stage 2')) {
    return `To evaluate the implementation, conformity, and effectiveness of the ${integrated ? 'integrated ' : ''}management system against ${standardText} for ${processLabel}, and determine whether the certification requirements are fulfilled.`;
  }

  return `To evaluate the conformity and effectiveness of the ${integrated ? 'integrated ' : ''}management system against ${standardText} for ${processLabel} under the ${methodologyLabel} methodology, including its ability to achieve intended outcomes and continually meet applicable requirements.`;
};
